export enum TaggableType {
  CLIENT = 'CLIENT',
  PARTICIPANT = 'PARTICIPANT',
  TOUR = 'TOUR',
  TRANSACTION = 'TRANSACTION',
  INSURANCE = 'INSURANCE',
  WAITLIST_ENTRY = 'WAITLIST_ENTRY',
}
